import React from 'react';
import { Grid, Button, makeStyles, colors } from '@material-ui/core';

import Description from 'components/typography/Description';

const useStyles = makeStyles({
  button: {
    backgroundColor: colors.red[400],
    color: colors.grey[50],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const FailedWarning = ({ onTryAgainButtonClick }) => {
  const classes = useStyles();

  return (
    <Grid container direction="column" spacing={1}>
      <Grid item>
        <Description>
          Most rated recipes load <b>failed</b>
        </Description>
      </Grid>

      <Grid item>
        <Button className={classes.button} onClick={onTryAgainButtonClick}>
          TRY AGAIN
        </Button>
      </Grid>
    </Grid>
  );
};

export default FailedWarning;
